import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moeda',
})
export class MoedaPipe implements PipeTransform {
  transform(valor: number): string {
    let valorFinal: string = 'R$';

    try {
      valor = Number(valor);
      let valorFixed = valor.toFixed(2).toString();
      valorFixed = valorFixed.replace('.', ',');
      valorFinal += valorFixed;
    } catch (ex) {
      console.warn('Valor não esperado na MoedaPipe', valor);
      if (isNaN(valor)) {
        valorFinal += ' - ';
      }
    }

    return valorFinal;
  }
}
